import Vue from 'vue';
import CustomDialog from "../views/buy/CustomDialog";


const DialogService = {
  install(Vue) {
    let instance = null;

    function show(component, options = {}) {
      return new Promise((resolve, reject) => {
        const DialogConstructor = Vue.extend(component);

        // 创建新的实例
        instance = new DialogConstructor({
          el: document.createElement('div'),
          propsData: options
        });

        // 将实例添加到文档中
        document.body.appendChild(instance.$el);

        instance.$on('submit', (result) => {
          resolve(result);
          instance.visible = false; // 关闭对话框
        });

        instance.visible = true;
      });
    }

    Vue.prototype.$dialog = { show };
  }
};

export default DialogService;
